function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
export function checkIsInRange(startPosition, endPosition, element) {
    var elementEndPosition = element.startPosition + element.duration;
    return element.startPosition >= startPosition && elementEndPosition < endPosition;
}
export function checkIsInBounds(position, element) {
    var endPosition = element.startPosition + element.duration;
    return position >= element.startPosition && position < endPosition;
}
export function parseTimeColonFormat(time) {
    if (!time) {
        return null;
    }
    // Regex matching a time with colon in between group
    // First group matches hours, with a minimum of two digits
    // Second group matches minutes with two digits
    // Third group matches seconds and milliseconds
    // Example of time: 3633:07:37.025
    var results = /^(?:(\d{2,}):)?(\d{2}):(\d{2}\.\d{2,})$/.exec(time);
    if (!results || results[0] === '') {
        return null;
    }
    var hours = Number(results[1]) || 0;
    var minutes = Number(results[2]) || 0;
    var seconds = Number(results[3]) || 0;
    var milliseconds = Number(results[4]) || 0;
    return milliseconds / 1000 + seconds + minutes * 60 + hours * 3600;
}
export var VTT_TEXT_MIMETYPES = [
    'text/vtt',
    'text/vtt; codecs="vtt"',
    'text/vtt; codecs="wvtt"'
];
export var TTML_TEXT_MIMETYPES = [
    'application/ttml+xml'
];
export var MP4_VTT_MIMETYPES = [
    'application/mp4; codecs="wvtt"'
];
export var MP4_TTML_MIMETYPES = [
    'application/mp4; codecs="stpp"',
    'application/mp4; codecs="stpp.ttml.im1t"',
    'application/mp4; codecs="stpp.TTML.im1t"'
];
export var TEXT_MIMETYPES = _to_consumable_array(VTT_TEXT_MIMETYPES).concat(_to_consumable_array(TTML_TEXT_MIMETYPES), _to_consumable_array(MP4_VTT_MIMETYPES), _to_consumable_array(MP4_TTML_MIMETYPES));

//# sourceMappingURL=subtitles-utils.js.map